import React, { useRef, useState } from "react";
import EditIcon from "assets/images/components/EditIcon";
import enFlag from "assets/images/english.svg";
import nlFlag from "assets/images/nl.svg";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import AboutIcon from "assets/images/components/AboutIcon";
import TablesIcon from "assets/images/components/TablesIcon";
import { useOnClickOutside } from "utils/useOnClickOutside";
import Dropdown from "components/Dropdown";
import ArrowDownIcon from "assets/images/components/ArrowDownIcon";
const available_languages = [
  { value: "en", icon: enFlag },
  { value: "nl", icon: nlFlag },
];

export const Header = () => {
  const { i18n, t } = useTranslation();
  const ref = useRef();
  const menuRef = useRef();
  const location = useLocation();

  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  useOnClickOutside(ref, () => setShowLangDropdown(false));
  useOnClickOutside(menuRef, () => setShowMenuDropdown(false));

  const getSelectedLanguageIcon = () => {
    return available_languages.find(
      (lang) => lang.value === i18n.resolvedLanguage
    ).icon;
  };


  const tablesIsActiveClass = (location.pathname.startsWith("/tables") ? ' active': '');
  return (
    <header className="header">
      <span className="logo">red to blue<span className="logo__component">&nbsp;|&nbsp;{t("header.component")}</span></span>
      <nav>
        <ul>
          <li>
            <NavLink to="/">
              <EditIcon />
              <span>{t("header.calculation")}</span>
            </NavLink>
          </li>
          <li className="header__dropdown--trigger" ref={menuRef}>
            <a
              href="/"
              className={tablesIsActiveClass}
              onClick={(e) => {
                e.preventDefault();
                setShowMenuDropdown(!showMenuDropdown);
              }}
            >
              <TablesIcon />
              <span>{t("header.tables")}</span>
            </a>
            <Dropdown showDropdown={showMenuDropdown} className="menu">
              <ul>
                <li>
                  {/* TODO see why click outside ref doesn't close dropdown  and remove onclicks on navlinks*/}
                  <NavLink
                    to="/tables/life-cycle"
                    onClick={() => setShowMenuDropdown(!showMenuDropdown)}
                  >
                    <span>{t("tables.life-cycle.title")}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tables/premium-ladder"
                    onClick={() => setShowMenuDropdown(!showMenuDropdown)}
                  >
                    <span>{t("tables.premium-ladder.title")}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tables/pension-plan"
                    onClick={() => setShowMenuDropdown(!showMenuDropdown)}
                  >
                    <span>{t("tables.pension-plan.title")}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tables/expenses"
                    onClick={() => setShowMenuDropdown(!showMenuDropdown)}
                  >
                    <span>{t("tables.expenses.title")}</span>
                  </NavLink>
                </li>
              </ul>
            </Dropdown>
          </li>
          <li>
            <NavLink to="/about">
              <AboutIcon />
              <span>{t("header.about")}</span>
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="language" ref={ref}>
        <span
          onClick={() => setShowLangDropdown(!showLangDropdown)}
          className="language__trigger"
        >
          <img
            src={getSelectedLanguageIcon()}
            alt="selected-language"
            width={20}
            height={20}
          />
          <span>{i18n.resolvedLanguage.toUpperCase()}</span>
          <ArrowDownIcon
            className={`language__icon language__icon--${
              showLangDropdown ? "up" : "down"
            }`}
          />
        </span>
        <Dropdown showDropdown={showLangDropdown} className="language">
          <div className="language__dropdown">
            {available_languages.map((lang) => (
              <div
                key={lang.value}
                className={`language__option ${
                  lang.value === i18n.resolvedLanguage
                    ? "language__option--selected"
                    : ""
                }`}
                onClick={() => {
                  i18n.changeLanguage(lang.value);
                  setShowLangDropdown(false);
                }}
              >
                <img src={lang.icon} alt={lang.value} width={20} height={20} />
                <span>{lang.value.toUpperCase()}</span>
              </div>
            ))}
          </div>
        </Dropdown>
      </div>
    </header>
  );
};
